<div *ngIf="message?.length" class="alert alert-{{ type }}">
    <button *ngIf="closeButton" type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onRemove($event)">
        <span aria-hidden="true">&times;</span>
    </button>
    {{ message }}
</div>
